<template>
  <div class="box">
  
    <template>
      <template v-for="item in list">
        <div class="item" v-if="item.id" :key="item.id">
          <div class="left-item">
            <thumbbar
              :value="item.thumb"
              :border="4"
              :width="200"
              :height="120"
            ></thumbbar>
          
          </div>
          <div class="right-item">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-info">
                  <div class="item-text">
                      已完成：<span>{{ item.learnedCount }}</span> / 共{{
                  item.courseCount
                      }}课程
                  </div>
              </div>
              <div class="item-progress">
                  <!-- 进度条 -->
                  <el-progress :text-inside="true" :stroke-width="16" :percentage="item.progress" :color="item.progress==100?'#409eff':''" :status="item.progress==100?'success':'warning'"></el-progress>
              </div>
          </div>
          
          <div
            class="button completed"
            v-if="item.isLearned === 1"
            @click="goDetail(item.id)"
          >
            学习完成
          </div>
          <div class="button continue" v-else @click="goDetail(item.id)">
            继续学习
          </div>
        </div>
      </template>
    </template>

  </div>
</template>
<script>
    import thumbbar from "@/components/training/thumb-bar.vue";
export default {
  components: {
        thumbbar
  },
  props: ["list"],
  data() {
    return {
      loading: false,
      visiable: false,
      cid: null,
    };
  },
  methods: {
 
    goDetail(id) {
      this.$router.push({
        name: "pkgDetail",
        query: {
          id: id
        },
      });
    },
    
  },
};
</script>
<style lang="scss" scoped>
    .box {
        width: 100%;
        height: 100%;

        .item {
            width: 100%;
            height: 120px;
            display: flex;
            flex-direction: row;
            margin-bottom: 30px;
 
            &:last-child {
                margin-bottom: 0px;
            }

            .left-item {
                width: 200px;
                height: 120px;
                border-radius: 4px;
                overflow: hidden;
                position: relative;
                margin-right: 30px;
                background: #f0f0f8;

                .icon {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    width: 66px;
                    height: 30px;
                    background: #ff4d4f;
                    border-radius: 4px 0px 4px 0px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 14px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }

            .right-item {
                flex: 1;
                height: 120px;
                margin-right: 30px;

                .item-title {
                    width: 700px;
                    height: auto;
                    font-size: 16px;
                    font-weight: 600;
                    color: #333333;
                    line-height: 16px;
                    margin-top: 20px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .item-progress {
                    width: 30%;
                    margin-top: 20px;
                }

                .item-info {
                    width: 700px;
                    height: auto;
                    display: flex;
                    flex-direction: row;
                    margin-top: 20px;



                    .item-text {
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 14px;
                        margin-right: 30px;

                        span {
                            color: #04c877;
                        }
                    }

                    .item-progress {
                        font-size: 14px;
                        font-weight: 400;
                        color: #ff4d4f;
                        line-height: 14px;
                        margin-right: 30px;
                    }
                }
            }

            .button {
                width: 96px;
                height: 44px;
                border-radius: 4px;
                font-size: 16px;
                font-weight: 400;
                color: #3ca7fa;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 37px;
                cursor: pointer;

                &:hover {
                    opacity: 0.8;
                }

                &.completed {
                    background: #f4fafe;
                }

                &.continue {
                    color: #fff;
                    background: #3ca7fa;
                }

                &.detail {
                    color: #666666;
                    border: 1px solid #cccccc;
                    margin-right: 30px;
                }
            }
        }

        ::v-deep .el-progress-bar__innerText {
            color: #FFF !important;
        }
    }
</style>
